import { styled, Typography } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const ColWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasValue' && prop !== 'isClickable',
})<{ hasValue: boolean; isClickable?: boolean }>(({ theme, hasValue, isClickable }) => ({
  color: !hasValue ? theme.palette.text.secondary : 'inherit',
  fontStyle: !hasValue ? 'italic' : 'normal',
  cursor: isClickable ? 'pointer' : 'default',
  '&:hover': {
    textDecoration: isClickable ? 'underline' : 'none',
  },
}));
